import SeoHead from '../../components/SeoHead';
import { Global } from "@sourceflow-uk/sourceflow-sdk";
import "@sourceflow-uk/job-search/dist/bundle.css";
import React from "react";
import SubBanner from '../../components/SubBanner';
import JobSearch from '../../components/AllJobs';
import Header from '../../components/MainHeader';

export default function jobSearchIndex({
    global,
    // sectorIds
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Find Work that suits you | Gap Personnel`}
                // description={`Check out all of our driving jobs including HGV vacancies. If you are looking for full-time, part-time or temporary driving jobs please contact us today.`}
                canonical_link={`/jobs/`}
            />
            <Header
                employerNav={false}
            />
            <SubBanner
                global={global}
                pathPrefix={`job_search_page.sub_banner`}
                customClass={`mb-5 secondary-banner all-jobs-page`}
                buttonTitle={`Job search`}
                buttonLink={``}
                heading={`Find work that suits you`}
                bannerImage="/site-assets/images/job-search-banner.jpg"
                bannerImageAlt="Driving Force Job Search Banner"
            />
            <JobSearch
                customClass={`jobs-page`}
                // sectorIds={sectorIds}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = await Global();
    //For filtering jobs search with sectors
    // const sector = await Collection('specialisms')
    // const sectorIds = sector.map('id').getItems()
    // const sectorIds = sector
    //     //Exclude from getting Recruitment Sector value
    //     // .filter(item => item.id !== '2400a212-abe4-4e55-a0dd-8763dc6140fa')
    //     .map(item => item.id).getItems();
    return {
        props: {
            global: global.toJson(),
            // sectorIds
        },
    };
}